export function normalizeMusicRequest(value='') {
  return String(value)
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g,'')
    .replace(/&/g,' and ')
    .replace(/[^a-z0-9]+/g,' ')
    .trim()
    .replace(/\s+/g,' ');
}

export function getMusicRequestKey(song) {
  const title=normalizeMusicRequest(song.title);
  const artist=normalizeMusicRequest(song.artist);

  if (!title && !artist) return '';

  return `${title}|${artist}`;
}

export function getDuplicateMusicRequestIds(songs) {
  const seen=new Set();
  const duplicateIds=new Set();

  songs.forEach((song)=>{
    const key=getMusicRequestKey(song);

    if (!key) return;

    if (seen.has(key)) {
      duplicateIds.add(song.id);
      return;
    }

    seen.add(key);
  });

  return duplicateIds;
}

export function removeDuplicateMusicRequests(songs) {
  const seen=new Set();

  return songs.filter((song)=>{
    const key=getMusicRequestKey(song);

    if (!key || seen.has(key)) {
      return !key;
    }

    seen.add(key);
    return true;
  });
}